import { Box, Stack } from '@mui/material';
import { Loading } from 'components/Loading';
import { useGetCandidateProfileListQuery } from 'generated-graphql/hooks/apollo-hooks';
import { CandidateProfileTableHeader } from 'modules/candidate-profile/components/CandidateProfileTableHeader';
import { CandidateProfileListProps } from 'modules/candidate-profile/types/CandidateProfileListProps';
import {
  layoutContainerPaddingX,
  layoutContainerPaddingY
} from 'services/navigation/components/PrivateRoute';

type VisibleTalentListGateProps = {
  talentPoolId: string;
  candidateProfileListProps: CandidateProfileListProps;
  children: React.ReactNode;
};

// A list the user can't see shows only its "not found" header, so its
// candidates are never searched.
export const VisibleTalentListGate: React.FC<VisibleTalentListGateProps> = ({
  talentPoolId,
  candidateProfileListProps,
  children
}) => {
  const { data, loading } = useGetCandidateProfileListQuery({
    variables: { id: talentPoolId }
  });

  if (loading) {
    return (
      <Stack alignItems="center" justifyContent="center" py="60px">
        <Loading size="40px" />
      </Stack>
    );
  }

  if (!data?.getCandidateProfileListForUser) {
    return (
      <Box px={layoutContainerPaddingX} py={layoutContainerPaddingY}>
        <CandidateProfileTableHeader
          candidateProfileListProps={candidateProfileListProps}
          conversationPanelOptions={null}
        />
      </Box>
    );
  }

  return <>{children}</>;
};
